// client/src/components/common/SEO.js
import { useEffect } from "react";

function setOrUpdateMetaByName(name, content) {
  if (content == null) return;
  let tag = document.querySelector(`meta[name='${name}']`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setOrUpdateMetaByProperty(property, content) {
  if (content == null) return;
  let tag = document.querySelector(`meta[property='${property}']`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setOrUpdateLink(rel, href) {
  if (!href) return;
  let link = document.querySelector(`link[rel='${rel}']`);
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", rel);
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

export default function SEO({
  title,
  description,
  canonical,
  robots = "index,follow",
  lang,
  og = {},
  twitter = {},
  structuredData,
}) {
  // Extract specific fields to use as stable dependencies
  const ogTitle = og?.title;
  const ogDescription = og?.description;
  const ogUrl = og?.url;
  const ogType = og?.type;
  const ogImage = og?.image;
  const ogLocale = og?.locale;

  const twCard = twitter?.card;
  const twTitle = twitter?.title;
  const twDescription = twitter?.description;
  const twImage = twitter?.image;

  const sd = structuredData;
  useEffect(() => {
    if (title) document.title = title;

    if (typeof lang === "string" && lang) {
      document.documentElement.setAttribute("lang", lang);
    }

    if (description) setOrUpdateMetaByName("description", description);
    if (robots) setOrUpdateMetaByName("robots", robots);
    if (canonical) setOrUpdateLink("canonical", canonical);

    if (ogTitle || title) setOrUpdateMetaByProperty("og:title", ogTitle || title);
    if (ogDescription || description)
      setOrUpdateMetaByProperty("og:description", ogDescription || description);
    if (ogUrl || canonical) setOrUpdateMetaByProperty("og:url", ogUrl || canonical);
    if (ogType) setOrUpdateMetaByProperty("og:type", ogType);
    if (ogImage) setOrUpdateMetaByProperty("og:image", ogImage);
    if (ogLocale) setOrUpdateMetaByProperty("og:locale", ogLocale);

    if (twCard) setOrUpdateMetaByName("twitter:card", twCard);
    if (twTitle || title)
      setOrUpdateMetaByName("twitter:title", twTitle || title);
    if (twDescription || description)
      setOrUpdateMetaByName("twitter:description", twDescription || description);
    if (twImage) setOrUpdateMetaByName("twitter:image", twImage);

    const existing = document.querySelectorAll(
      'script[type="application/ld+json"][data-managed="seo"]'
    );
    existing.forEach((n) => n.parentNode.removeChild(n));

    const sdArray = !sd
      ? []
      : Array.isArray(sd)
      ? sd
      : [sd];
    sdArray.forEach((obj) => {
      if (!obj) return;
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-managed", "seo");
      script.text = JSON.stringify(obj);
      document.head.appendChild(script);
    });
  }, [
    title,
    description,
    canonical,
    robots,
    lang,
    ogTitle,
    ogDescription,
    ogUrl,
    ogType,
    ogImage,
    ogLocale,
    twCard,
    twTitle,
    twDescription,
    twImage,
    sd,
  ]);

  return null;
}

